import { FC } from 'react';
import { Divider, Grid } from '@csp/csp-web-ui';
import { DividerProps, GridProps } from '@mui/material';

type Props = GridProps & {
  dividerProps?: DividerProps;
};

export const DividerCol: FC<Props> = ({ my = 1.5, xs = 12, dividerProps, ...rest }) => (
  <Grid item xs={xs} my={my} {...rest}>
    <Divider {...dividerProps} />
  </Grid>
);
